import {
    SUBSCRIPTION_STATE_CUSTOMER_PORTAL,
    SUBSCRIPTION_STATE_NOT_ACTIVE,
    SUBSCRIPTION_STATE_TRIAL_AVAILABLE,
    SUBSCRIPTION_STATE_TRIAL_USED
} from "../selectors/subscription";
import * as subscriptionStatus from "../constants/subscription";
import {freeTrialLink} from "../config/app";

export const getLandingSubscriptionButtonLink = (subscriptionState) => {
    switch (subscriptionState) {
        case SUBSCRIPTION_STATE_TRIAL_AVAILABLE:
            return freeTrialLink;
        case SUBSCRIPTION_STATE_TRIAL_USED:
        case SUBSCRIPTION_STATE_NOT_ACTIVE:
        case SUBSCRIPTION_STATE_CUSTOMER_PORTAL:
        default:
            return '/dashboard';
    }
}
export const modifySubscriptionInfo = (subscriptionInfo) => {
    if (subscriptionInfo.isCancelled) {
        subscriptionInfo.subscriptionStatus = subscriptionStatus.STATUS_CANCELED;
    }

    return subscriptionInfo;
}